var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-alert", {
    staticClass: "completed-step-banner-wrapper mb-3",
    attrs: {
      title: "info alert",
      type: "info",
      "show-icon": "",
      closable: false,
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [
            _c("p", { staticClass: "title m-0 mb-2" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "pages.businessPlan.completedStepBanner.howToCreateMyBusinessPlan"
                    )
                  ) +
                  " "
              ),
            ]),
            _c("p", { staticClass: "description m-0" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "pages.businessPlan.completedStepBanner.markSectionsInBusinessGuideAs"
                    )
                  ) +
                  " "
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }